<template>
    <div class="pane" v-if="isShow">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'pane',
    props: {
        //标题
        label: {
        type: String,
        default: ''
    }
    },
    data: function () {
        return {
            //显示或隐藏
            isShow: true
        }
    },
    methods: {
        //通知父组件，更新标题
        init() {
            this.$parent.init();
        }
    },
    watch: {
        //当 label 值发生变化时，更新标题
        label() {
            this.init();
        }
    },
    //挂载时，更新标题
    mounted() {
        this.init();
    }
}
</script>
<style>
.pane {
    margin-top: 10px;
    text-align: justify;
   /* margin-top: 26px;
    font-size: 16px;
    line-height: 24px;
    color: #333;
    text-align: justify;*/
}
</style>
